import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { I18nNamespace } from '@/lib/i18n-namespaces';
import { Button } from '@/components/ui/Button';
import { DetailRow } from './DetailRow';

const COPIED_FEEDBACK_MS = 1500;

interface CopyableValueRowProps {
    label: string;
    value: string | null;
    displayValue: (value: string) => string;
    unavailable: React.ReactNode;
    status: React.ReactNode;
}

export function CopyableValueRow({
    label,
    value,
    displayValue,
    unavailable,
    status,
}: CopyableValueRowProps) {
    const { t } = useTranslation(I18nNamespace.SETTINGS);
    const [copied, setCopied] = useState(false);

    const copy = async () => {
        if (!value) {
            return;
        }
        try {
            await navigator.clipboard?.writeText(value);
            setCopied(true);
            window.setTimeout(() => setCopied(false), COPIED_FEEDBACK_MS);
        } catch {
            setCopied(false);
        }
    };

    return (
        <DetailRow label={label}>
            {value ? (
                <div className="flex items-center gap-2 justify-end">
                    <span
                        className="font-mono text-xs text-grey-100"
                        title={value}
                    >
                        {displayValue(value)}
                    </span>
                    <Button variant="tertiary" size="small" onClick={copy}>
                        {copied ? t('license.copied') : t('license.copy')}
                    </Button>
                    {status}
                </div>
            ) : (
                unavailable
            )}
        </DetailRow>
    );
}
